import { Outlet, useLocation } from "react-router-dom";
import EmployeesSideBar from "../pages/dashboard/employeesBoard/EmployeeSideBar";
import ProfileNav from "../pages/dashboard/profileNav";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
const EmployeeDashboardLayout = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const getPageTitle = (path) => {
    const lastSegment = path.split("/").filter(Boolean).pop();
    if (!lastSegment) return "Dashboard";
    return t(lastSegment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()));
  };
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);
  return (
    <div className="h-full grid grid-cols-[auto_1fr] bg-[#F9F8FE]">
      <div className="h-auto bg-white">
        <EmployeesSideBar />
      </div>
      <div className="min-h-screen px-5 py-3">
        <nav className="flex items-center justify-between gap-4 pb-6 ">
          <h1 className="text-2xl font-medium capitalize">{getPageTitle(pathname)}</h1>
          <ProfileNav />
        </nav>
        <Outlet />
      </div>
    </div>
  );
};

export default EmployeeDashboardLayout;
